import React, { useEffect, useState, useContext } from 'react'
import Swal from "sweetalert2";
import axios from 'axios';

import { AppContext } from '../../../services/AppContext';
import AuthContext from '../../../context/auth-context';

import { MdDelete, MdErrorOutline, MdSave, MdCheck } from "react-icons/md";

import useInput from '../../../hooks/useInput';
import useFileInput from '../../../hooks/useFileInput';
import useGetCarrera from '../../../hooks/useGetCarrera'
import useGetPaises from '../../../hooks/useGetPaises';

import useInputDatePicker from "../../../hooks/useInputDatePicker";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';


const EstudiosSuperioresForm = ({ token, setShowForm, formData, instituciones, grados, isUpdate, onCompletado }) => {
    
    const { setAppValues } = useContext(AppContext);
    const authContext = useContext(AuthContext);

    const [error, setError] = useState( !token );

    useEffect(() => {
        if( !token ){
            setError(true);

            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: "Sesión de usuario inválida.",
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });
        }

    }, [token]);

    const carreras = useGetCarrera();
    const paises = useGetPaises();

    // INPUT INSTITUCION
    const institucionValidacion = value => parseInt(value) > 0 && parseInt(value) < 12;
    const {
        value: institucion,
        isValid: institucionIsValid,
        isTouched: institucionIsTouched,
        divInput: divInstitucion,
        setInputValue: setInstitucionValue,
        valueChangeHandler: institucionChangeHanlder,
        inputBlurHandler: institucionBlurHandler,
        scrollToDiv: scrollToDivInstitucion
    } = useInput(institucionValidacion);

    // INPUT OTRA INSTITUCION
    const otraInstitucionValidacion = value => value.trim() !== "";
    const {
        value: otraInstitucion,
        isValid: otraInstitucionIsValid,
        isTouched: otraInstitucionIsTouched,
        setInputValue: setOtraInstitucionValue,
        valueChangeHandler: otraInstitucionChangeHanlder,
        inputBlurHandler: otraInstitucionBlurHandler
    } = useInput(otraInstitucionValidacion);

    // INPUT CARRERA

    //    const carreraValidacion = value => parseInt(value) > 0 && parseInt(value) < 34;

    const carreraValidacion = value => parseInt(value) > 0;
    const {
        value: carrera,
        isValid: carreraIsValid,
        isTouched: carreraIsTouched,
        divInput: divCarrera,
        setInputValue: setCarreraValue,
        valueChangeHandler: carreraChangeHanlder,
        inputBlurHandler: carreraBlurHandler,
        scrollToDiv: scrollToDivCarrera
    } = useInput(carreraValidacion);

    // INPUT OTRA CARRERA
    const otraCarreraValidacion = value => value.trim() !== "";
    const {
        value: otraCarrera,
        isValid: otraCarreraIsValid,
        isTouched: otraCarreraIsTouched,
        setInputValue: setOtraCarreraValue,
        valueChangeHandler: otraCarreraChangeHanlder,
        inputBlurHandler: otraCarreraBlurHandler
    } = useInput(otraCarreraValidacion);

    // INPUT GRADO OBTENIDO
    const gradoValidacion = value => parseInt(value) >= 1 && parseInt(value) <= 8;
    const {
        value: grado,
        isValid: gradoIsValid,
        isTouched: gradoIsTouched,
        divInput: divGrado,
        setInputValue: setGradoValue,
        valueChangeHandler: gradoChangeHanlder,
        inputBlurHandler: gradoBlurHandler,
        scrollToDiv: scrollToDivGrado
    } = useInput(gradoValidacion);

    // INPUT PAIS
    const paisValidacion = value => parseInt(value) > 0 && parseInt(value) < 206;
    const {
        value: pais,
        isValid: paisIsValid,
        isTouched: paisIsTouched,
        divInput: divPais,
        setInputValue: setPaisValue,
        valueChangeHandler: paisChangeHanlder,
        inputBlurHandler: paisBlurHandler,
        scrollToDiv: scrollToDivPais
    } = useInput(paisValidacion);

    // INPUT CIUDAD
    const ciudadValidacion = value => value.trim() !== "";
    const {
        value: ciudad,
        isValid: ciudadIsValid,
        isTouched: ciudadIsTouched,
        divInput: divCiudad,
        setInputValue: setCiudadValue,
        valueChangeHandler: ciudadChangeHanlder,
        inputBlurHandler: ciudadBlurHandler,
        scrollToDiv: scrollToDivCiudad
    } = useInput(ciudadValidacion);

    // INPUT DURACION
    const duracionValidacion = value => parseInt(value) >= 0 && parseInt(value) <= 100;
    const {
        value: duracion,
        isValid: duracionIsValid,
        isTouched: duracionIsTouched,
        divInput: divDuracion,
        setInputValue: setDuracionValue,
        valueChangeHandler: duracionChangeHanlder,
        inputBlurHandler: duracionBlurHandler,
        scrollToDiv: scrollToDivDuracion
    } = useInput(duracionValidacion);

        //INPUT 2 FECHA INICIO

        const fechaInicioValidacion2= value => value !== null; 
        const {
            value: fechaInicio2,
            isValid: fechaInicioIsValid2,
            isTouched: fechaInicioIsTouched2,
            divInput: divFechaInicio2,
            setInputValue: setFechaInicioValue2,
            valueChangeHandler: fechaInicioChangeHanlder2,
            inputBlurHandler: fechaInicioBlurHandler2,
            scrollToDiv: scrollToDivFechaInicio2
        } = useInputDatePicker(fechaInicioValidacion2);
    

    
    // INPUT 2 FECHA FIN
    const fechaFinValidacion2 = value => value !== null ;
    const {
        value: fechaFin2,
        isValid: fechaFinIsValid2,
        isTouched: fechaFinIsTouched2,
        divInput: divFechaFin2,
        setInputValue: setFechaFinValue2,
        valueChangeHandler: fechaFinChangeHanlder2,
        inputBlurHandler: fechaFinBlurHandler2,
        resetInput: resetInputFechaFin2,
        scrollToDiv: scrollToDivFechaFin2
    } = useInputDatePicker(fechaFinValidacion2);



    //ID FOR UPDATE OR DELETE
    const [idEducacion, setIdEducacion] = useState("");

    //INPUT ESTUDIA ACTUAL MENTE 
    /*const [estudiaActualmente, setEstudiaActualmente] = useState( "fechaFin" in formData && formData.fechaFin === null );
    const estudiaActualmenteIsValid = typeof estudiaActualmente === "boolean";
    const estudiaActualmenteChangeHandler = (event) => {
        setEstudiaActualmente(event.target.checked);
        if(event.target.checked){
            resetInputFechaFin();
            resetInputTituloFile();
                       // resetInputFechaFin2();
        }
    };*/

    // INPUT ESTUDA ACTUALMENTE 2

    //INPUT ESTUDIA ACTUAL MENTE 
    const [estudiaActualmente2, setEstudiaActualmente2] = useState( "fechaFin" in formData && formData.fechaFin === null );
    const estudiaActualmenteIsValid2 = typeof estudiaActualmente2 === "boolean";
    const estudiaActualmenteChangeHandler2 = (event) => {
        setEstudiaActualmente2(event.target.checked);
        if(event.target.checked){
            resetInputFechaFin2();

            
        }
    };


    const [flag, setFlag] = useState(false);

    useEffect(
        () => {
            // Set de valores iniciales al editar
            if(!flag){
                setInstitucionValue(    ("institucion" in formData && institucion === "")           ? formData.institucion : institucion );
                setOtraInstitucionValue(("otraInstitucion" in formData && otraInstitucion === "")   ? formData.otraInstitucion : otraInstitucion );
                setGradoValue(          ("grado" in formData && grado === "")                       ? formData.grado : grado );
                setCarreraValue(        ("carrera" in formData && carrera === "")                   ? formData.carrera : carrera );
                setOtraCarreraValue(    ("otraCarrera" in formData && otraCarrera === "")           ? formData.otraCarrera : otraCarrera );
                setPaisValue(           ("pais" in formData && pais === "")                         ? formData.pais : pais );
                setCiudadValue(         ("ciudad" in formData && ciudad === "")                     ? formData.ciudad : ciudad );
                setDuracionValue(       ("duracion" in formData && duracion === "")                 ? formData.duracion : duracion );
              //  setFechaInicioValue(    ("fechaInicio" in formData && fechaInicio === "")           ? formData.fechaInicio : fechaInicio );
              //  setFechaFinValue(       ("fechaFin" in formData && formData.fechaFin !== null && fechaFin === "" && !estudiaActualmente) ? formData.fechaFin : fechaFin );
                setFechaInicioValue2(    ("fechaInicio" in formData && fechaInicio2 === null)           ? formData.fechaInicio : fechaInicio2 ); //
                setFechaFinValue2(       ("fechaFin" in formData && formData.fechaFin !== null && fechaFin2 === null && !estudiaActualmente2) ? formData.fechaFin : fechaFin2 );//
                setIdEducacion(         ("id" in formData && idEducacion === "" )                   ? formData.id : idEducacion );
                if(institucion !== ""){
                    setFlag(true)
                }
            }
        },
        [
            formData,
            setInstitucionValue, institucion,
            setOtraInstitucionValue, otraInstitucion,
            setCarreraValue, carrera,
            setOtraCarreraValue, otraCarrera,
            setGradoValue, grado,
            setPaisValue, pais,
            setCiudadValue, ciudad,
            setDuracionValue, duracion,
         //   setFechaInicioValue, fechaInicio,
          //  setFechaFinValue, fechaFin,
            //
            //
            setFechaInicioValue2,fechaInicio2,
            setFechaFinValue2,fechaFin2,
         //   estudiaActualmente,
            estudiaActualmente2,
            setIdEducacion, idEducacion,
            setFlag, flag
        ]
    );

    let formIsValid = false;
    /* let fechaInicioFinIsValid = false;

    if( estudiaActualmenteIsValid ){
        if( estudiaActualmente && fechaInicioIsValid){
            fechaInicioFinIsValid = true;
        } else if( !estudiaActualmente && fechaInicioIsValid && fechaFinIsValid && (Date.parse(fechaInicio) < Date.parse(fechaFin)) ){
            fechaInicioFinIsValid = true;
        }
    }*/

    //Añadiendo para los nuevos inputs
    let fechaInicioFinIsValid2 = false;//false

    if( estudiaActualmenteIsValid2 ){
        if( estudiaActualmente2 && fechaInicioIsValid2){
            fechaInicioFinIsValid2 = true;
        } else if( !estudiaActualmente2 && fechaInicioIsValid2 && fechaFinIsValid2 && (Date.parse(fechaInicio2) < Date.parse(fechaFin2)) ){
            fechaInicioFinIsValid2 = true;
        }
    }


    if( institucionIsValid &&
        carreraIsValid &&
        gradoIsValid &&
        paisIsValid &&
        ciudadIsValid &&
        duracionIsValid &&
        //fechaInicioIsValid && 
        fechaInicioIsValid2 &&
       // fechaInicioFinIsValid &&
        fechaInicioFinIsValid2){

       /* if(estudiaActualmenteIsValid){
            if(estudiaActualmente){
                formIsValid = true;
            } else if(!estudiaActualmente && fechaFinIsValid && tituloFileIsValid) {
                formIsValid = true;
            }
        }*/

        /*Segunda condición*/

        if(estudiaActualmenteIsValid2){
            if(estudiaActualmente2){
                formIsValid = true;
            } else if(!estudiaActualmente2 && fechaFinIsValid2 ) {
                formIsValid = true;
            }
        }

    }

    if( institucionIsValid && parseInt(institucion) === 8 && !otraInstitucionIsValid ){
        formIsValid = false;
    }

    if( carreraIsValid && parseInt(carrera) === 32 && !otraCarreraIsValid ){
        formIsValid = false;
    }
    

    const formSubmitHanlder = async(event) => {
        event.preventDefault();

        // Validacion visual de inputs
        institucionBlurHandler();
        otraInstitucionBlurHandler();
        carreraBlurHandler();
        otraCarreraBlurHandler();
        gradoBlurHandler();
        paisBlurHandler();
        ciudadBlurHandler();
        duracionBlurHandler();
      //  fechaInicioBlurHandler();
      fechaInicioBlurHandler2();
      /*if( estudiaActualmenteIsValid && !estudiaActualmente){
          fechaFinBlurHandler();
         // tituloFileBlurHandler();
      }*/
      /**/
      if( estudiaActualmenteIsValid2 && !estudiaActualmente2){
          fechaFinBlurHandler2();
      }

        if(!formIsValid){

            if(!institucionIsValid){
                scrollToDivInstitucion();
                return;
            }

            if(institucionIsValid && parseInt(institucion) === 8 && !otraInstitucionIsValid){
                scrollToDivInstitucion();
                return;
            }

            if(!carreraIsValid){
                scrollToDivCarrera();
                return;
            }

            if(carreraIsValid && parseInt(carrera) === 32 && !otraCarreraIsValid){
                scrollToDivCarrera();
                return;
            }

            if(!gradoIsValid){
                scrollToDivGrado();
                return;
            }

            if(!paisIsValid){
                scrollToDivPais();
                return;
            }

            if(!ciudadIsValid){
                scrollToDivCiudad();
                return;
            }

            if(!duracionIsValid){
                scrollToDivDuracion();
                return;
            }

           /*  if(!fechaInicioIsValid){
                scrollToDivFechaInicio();
            }*/


            /*Añadiendo*/
            if(!fechaInicioIsValid2){
                scrollToDivFechaInicio2();
            }

    
            /*if(estudiaActualmenteIsValid && !estudiaActualmente && !fechaFinIsValid){
                scrollToDivFechaFin();
            }*/

            /*Añadiendo*/ 
            if(estudiaActualmenteIsValid2 && !estudiaActualmente2 && !fechaFinIsValid2){
                    scrollToDivFechaFin2();
                }

          

            return;
        }

        var event_date = new Date(fechaInicio2);
        let fecha_inicio_procesada = JSON.stringify(event_date)
        fecha_inicio_procesada = fecha_inicio_procesada.slice(1,11)


        let fecha_fin_procesada = '';

        if(fechaFin2 !== null){
        var event_date2 = new Date(fechaFin2);
        fecha_fin_procesada = JSON.stringify(event_date2)
        fecha_fin_procesada = fecha_fin_procesada.slice(1,11)
        }
     
        const form_data = new FormData();
        form_data.append('idToken', authContext.token);
        form_data.append('universidad', institucion);
        form_data.append('otraUniversidad', otraInstitucion);
        form_data.append('carrera', carrera);
        form_data.append('otraCarrera', otraCarrera);
        form_data.append('grado', grado);
        form_data.append('pais', pais);
        form_data.append('ciudad', ciudad);
        form_data.append('duracion', duracion);
        form_data.append('fechaInicio', fecha_inicio_procesada);
        form_data.append('fechaFin', fecha_fin_procesada);
        form_data.append('estudiaActualmente', estudiaActualmente2);

        if(isUpdate){
            form_data.append('id', idEducacion);
            form_data.append('updateEstudiosSuperiores', 1);
        } else {
            form_data.append('saveEstudiosSuperiores', 1);
        }

        console.log([...form_data]);

        axios.post(process.env.REACT_APP_API_URL, form_data)
        .then(res => {

                if(res.data.STATUS && res.data.STATUS === "SUCCESS"){
                    setAppValues(
                        prev => {
                            let perfil = prev.estudiosSuperiores ? prev.perfil : prev.perfil+20;
                            return { ...prev, estudiosSuperiores: true, perfil };
                        }
                    );
                    onCompletado('estudios-superiores');

                } else if(res.data.STATUS && res.data.STATUS === "ERROR"){
                    Swal.fire({
                        icon: 'error',
                        title: "¡Error!",
                        text: res.data.ERROR.MESSAGE,
                        showConfirmButton: false,
                        showDenyButton: true,
                        denyButtonText: "Aceptar",
                        backdrop: true,
                        allowOutsideClick: false
                    });

                } else {
                    Swal.fire({
                        icon: 'error',
                        title: "¡Error!",
                        text: 'Ocurrió un problema, intentelo más tarde',
                        showConfirmButton: false,
                        showDenyButton: true,
                        denyButtonText: "Aceptar",
                        backdrop: true,
                        allowOutsideClick: false
                    });
                }
                setShowForm(false);
            })
            .catch((error) => {
                console.log(error)
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema, intentelo más tarde',
                    showConfirmButton: false,
                    timer: 3500
                });
            });

    };

    return (
        <>
        {
            error &&
            <div className="d-flex align-items-center justify-content-center" style={{ height: '565px' }}>
                <div className="text-center" style={{ color: 'rgba(0,0,0,.3)', fontSize: '2.5rem' }} >
                    <span style={{ fontSize: "7rem" }}><MdErrorOutline/></span>
                    <br />
                    ¡Error!
                </div>
            </div>
        }
        {
            !error &&
            <form className="row my-4" onSubmit={formSubmitHanlder}>

                {/* INSTITUCION */}
                <div className="col-md-10 offset-md-1 mb-3" ref={divInstitucion}>
                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='institucion' >Institución</label>
                    <select
                        className={`form-select form-select-sm shadow-sm ${institucionIsTouched ? ((institucionIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                        name='institucion'
                        value={institucion}
                        onChange={institucionChangeHanlder}
                        onBlur={institucionBlurHandler}
                        autoComplete='off' >
                        <option value="" defaultValue={'DEFAULT'} default={true} hidden={true}>Seleccionar institución</option>
                        {Array.isArray(instituciones) && instituciones.map(institucion => (
                            <option key={institucion.institucion} value={institucion.institucion}>{institucion.descripcion}</option>
                        ))}
                    </select>
                    <input 
                        type="text" 
                        className={`form-control form-control-sm shadow-sm mt-1 ${parseInt(institucion) === 8 ? '': 'd-none'} ${otraInstitucionIsTouched ? ((otraInstitucionIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                        name="otraInstitucion"
                        value={otraInstitucion}
                        onChange={otraInstitucionChangeHanlder}
                        onBlur={otraInstitucionBlurHandler}
                        placeholder="Nombre de otra institución"
                        autoComplete='off' />  
                    <div className={`invalid-feedback ${parseInt(institucion) === 8 ? '': 'd-none'}`} style={{userSelect: 'none'}}>
                        Campo obligatorio
                    </div>
                </div>
                
                {/* CARRERA */}
                <div className="col-md-10 offset-md-1 mb-3" ref={divCarrera}>
                    <label className="form-label text-black-50">Carrera</label>
                    <select
                        className={`form-select form-select-sm shadow-sm ${carreraIsTouched ? ((carreraIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                        name="carrera"
                        value={carrera}
                        onChange={carreraChangeHanlder}
                        onBlur={carreraBlurHandler} >
                        <option value="" defaultValue={'DEFAULT'} default={true} hidden={true}>Seleccionar carrera</option>
                        {Array.isArray(carreras) && carreras.map(carrera => (
                            <option key={carrera.carrera} value={carrera.carrera}>{carrera.descripcion}</option>
                        ))}
                    </select>

                    {/* OTRA CARRERA */}
                    <input
                        type="text"
                        className={`form-control form-control-sm shadow-sm mt-1 ${parseInt(carrera) === 32 ? '': 'd-none'} ${otraCarreraIsTouched ? ((otraCarreraIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                        placeholder="Nombre de otra carrera"
                        name="otraCarrera"
                        value={otraCarrera}
                        onChange={otraCarreraChangeHanlder}
                        onBlur={otraCarreraBlurHandler}
                        autoComplete='off' />
                    <div className={`invalid-feedback ${parseInt(carrera) === 32 ? '': 'd-none'}`} style={{userSelect: 'none'}}>
                        Campo obligatorio
                    </div>
                </div>

                {/* GRADO */}
                <div className="col-md-6 offset-md-1 mb-3" ref={divGrado}>
                    <label className="form-label text-black-50">Grado</label>
                    <select 
                        className={`form-select form-select-sm shadow-sm ${gradoIsTouched ? ((gradoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                        name="grado"
                        value={grado}
                        onChange={gradoChangeHanlder}
                        onBlur={gradoBlurHandler} >
                        <option value="" defaultValue={'DEFAULT'} default={true} hidden={true}>Seleccionar grado</option>
                        {grados.map(titulo => (
                            <option key={titulo.tipo_titulo} value={titulo.tipo_titulo}>{titulo.nombre}</option>
                        ))}
                    </select>
                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                        Campo obligatorio
                    </div>
                </div>

                {/* PAIS */}
                <div className="col-md-8 offset-md-1 mb-3" ref={divPais}>
                    <label className="form-label text-black-50">País</label>
                    <select 
                        className={`form-select form-select-sm shadow-sm ${paisIsTouched ? ((paisIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                        name="pais"
                        value={pais}
                        onChange={paisChangeHanlder}
                        onBlur={paisBlurHandler} >
                        <option value="" defaultValue={'DEFAULT'} default={true} hidden={true}>Seleccionar país</option>
                        {paises.map(pais => (
                            <option key={pais.PAIS} value={pais.PAIS}>{pais.NOMBRE}</option>
                        ))}
                    </select>
                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                        Campo obligatorio
                    </div>
                </div>

                {/* CIUDAD */}
                <div className="col-md-8 offset-md-1 mb-3" ref={divCiudad}>
                    <label className="form-label text-black-50">Ciudad</label>
                    <input 
                        type="text" 
                        className={`form-control form-control-sm shadow-sm ${ciudadIsTouched ? ((ciudadIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                        placeholder="Ingrese ciudad"
                        name="ciudad"
                        value={ciudad}
                        onChange={ciudadChangeHanlder}
                        onBlur={ciudadBlurHandler}
                        autoComplete='off' />
                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                        Campo obligatorio
                    </div>
                </div>

                <div className="col-md-10 offset-md-1 my-3"><hr /></div>

                {/* ESTUDIA ACTUALMENTE */}
                <div className="col-md-10 offset-md-1 mb-3">
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            className="form-check-input"
                            name="estudiaActualmente"
                            onChange={estudiaActualmenteChangeHandler2} 
                            checked={estudiaActualmente2} />
                        <label htmlFor="estudiaActualmente" className="form-check-label text-black-50">Actualmente estudio esta carrera</label>
                    </div>
                </div>

                {/* DURACION */}
                <div className="col-md-5 offset-md-1 mb-3" ref={divDuracion}>
                    <label className="form-label text-black-50">Duración</label>
                    <input
                        type="number"
                        className={`form-control form-control-sm shadow-sm ${duracionIsTouched ? ((duracionIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                        name='telefonoMovil' 
                        value={duracion}
                        min={0}
                        max={100}
                        onChange={duracionChangeHanlder}
                        onBlur={duracionBlurHandler}
                        autoComplete='off'
                        placeholder="Ingrese años" />
                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                        Campo obligatorio
                    </div>
                </div>
                <div className="col-md-7"></div>

             
                
                                   {/* FECHA INICIO */}


                                   <div className="col-md-5 offset-md-1 mb-3" ref={divFechaInicio2}>
<label className="form-label text-black-50">Fecha inicio</label>

<DatePicker
selected=  {(fechaInicio2 === null)  ? null :  moment(fechaInicio2).toDate()} 
name="fechaInicio2"
onChange={fechaInicioChangeHanlder2}
placeholderText={'dd / mm / yyyy'} 
className={`form-control form-control-sm shadow-sm ${fechaInicioIsTouched2 ? ((fechaInicioIsValid2 && fechaInicioFinIsValid2) ? 'is-valid' : 'is-invalid') : ''}`}
dateFormat = "dd / MM / yyyy"
onChangeRaw={(e) => e.preventDefault()}
onBlur={fechaInicioBlurHandler2}
//isClearable
showYearDropdown
scrollableYearDropdown
/>

<div className="invalid-feedback d-block" style={{userSelect: 'none'}}>
{ fechaInicioIsTouched2? (fechaInicioIsValid2 ? ( fechaInicioFinIsValid2 ? '' : 'La fecha inicio debe ser menor a la fecha de finalización' ) : 'Campo obligatorio' ) : '' }

</div>

    
</div>

                   {/* FECHA FIN */}
                   <div className="col-md-5 mb-3" ref={divFechaFin2}>
<label className="form-label text-black-50">Fecha Fin</label>

<DatePicker
selected= {(fechaFin2 === null ? null :  moment(fechaFin2).toDate())} 
onChange={fechaFinChangeHanlder2}
placeholderText={'dd / mm / yyyy'} 
className={`form-control form-control-sm shadow-sm ${estudiaActualmente2? '' : (fechaFinIsTouched2 ? ((fechaFinIsValid2 && fechaInicioFinIsValid2) ? 'is-valid' : 'is-invalid') : '')}`}
dateFormat = "dd / MM / yyyy"
onChangeRaw={(e) => e.preventDefault()}
onBlur={fechaFinBlurHandler2}
//isClearable
disabled={estudiaActualmente2}
showYearDropdown
scrollableYearDropdown
/>

<div className="invalid-feedback d-block" style={{userSelect: 'none'}}>
{(fechaFinIsTouched2?  (fechaFinIsValid2 && fechaInicioFinIsValid2 ? '' : (fechaFinIsValid2 && !fechaInicioFinIsValid2 ? '' :'Campo obligatorio')): '') }




</div>

    
</div>


                {/* <div className="col-md-10 offset-md-1 my-3"><hr /></div> */}


                {/* EDITAR/GUARDAR */}
                <div className="col-md-11 mt-4" style={{ textAlign: 'right' }}>
                    <div className="btn-group">
                        <button 
                            className={`btn ${false ? 'btn-dark':'btn-outline-dark'}`}
                            onClick={() => setShowForm(false)}
                            type="button"
                            // disabled={!false} 
                            >
                            <MdDelete /> Descartar
                        </button>
                        <button 
                            className={`btn ${false ? 'btn-outline-danger':'btn-danger'}`}
                            type="submit"
                            // disabled={false} 
                            >
                            <MdSave /> Guardar
                        </button>
                    </div>
                </div>

            </form>
        }
        </>

    )
}

export default EstudiosSuperioresForm;